import Marquee from "@/components/Marquee";
import Reveal from "@/components/Reveal";

export default function Story() {
  return (
    <div data-testid="story-page" className="bg-[#F5ECD7] text-[#121212]">
      {/* Hero */}
      <section className="section-pad pt-16 md:pt-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[#9B2226] mb-6">Our Story</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.98]">
            From <span className="font-serif-italic font-normal">Saginaw</span>
            <br />
            to <span className="text-[#9B2226]">Charlotte</span>.
          </h1>
          <p className="mt-8 max-w-2xl text-lg md:text-xl text-[#121212]/70 leading-relaxed">
            #TacoSoul is more than a food truck. It's a love letter to two
            cultures that taught us how to feed each other.
          </p>
        </div>
      </section>

      {/* Image break */}
      <section className="relative">
        <div className="aspect-[16/8] md:aspect-[16/6] overflow-hidden">
          <img src="/brand-images/founder.jpg" alt="Lebbiona Couch, founder of TacoSoul" className="w-full h-full object-cover object-top" />
        </div>
      </section>

      {/* Narrative */}
      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <Reveal>
            <h2 className="font-display text-3xl md:text-5xl tracking-tighter leading-tight">
              Growing up in Saginaw, Michigan, the line between cultures was the
              kitchen table.
            </h2>
          </Reveal>
          <Reveal delay={100} className="mt-10 text-lg leading-relaxed text-[#121212]/75 space-y-6">
            <p>
              Our Black and Hispanic neighbors shared more than backyards. They
              shared brisket and tortillas, jerk seasoning and adobo, music and
              memory. And somewhere in that crosspollination — under a porch
              light, on a folding card table — a Saginaw deep-fried taco was
              born.
            </p>
            <p>
              Founder <strong>Lebbiona Couch</strong> grew up tasting that
              fusion. When she moved to Charlotte, she couldn't find it
              anywhere. So she built it. Out of one matte-black food trailer.
              One signature crispy shell. One bold idea: that street food can
              be a cultural experience — premium, soulful, and proudly her own.
            </p>
            <p className="font-serif-italic text-2xl md:text-3xl text-[#121212]">
              "We're not a Mexican restaurant. We're not a soul food kitchen.
              We're what happens when both cultures sit down to eat — together."
            </p>
            <p className="text-sm uppercase tracking-[0.25em] text-[#9B2226]">— Lebbiona Couch, Founder</p>
          </Reveal>
        </div>
      </section>

      {/* Values band */}
      <section className="bg-[#121212] text-[#F5ECD7]">
        <Marquee items={["Bold", "Soulful", "Vibrant", "Refined", "Multicultural", "Crispy"]} />
      </section>

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-3 gap-8">
          {[
            { title: "Two Cultures, One Plate", body: "Black + Hispanic kitchens, side by side in every bite." },
            { title: "Premium Street Food", body: "Crispy, refined, never fast food. Always cooked fresh." },
            { title: "Community First", body: "Festivals, weddings, block parties, breweries — we show up." },
          ].map((v, i) => (
            <Reveal key={i} delay={i * 100} className="p-8 border-l-2 border-[#9B2226]">
              <h3 className="font-display text-2xl md:text-3xl tracking-tight">{v.title}</h3>
              <p className="mt-3 text-[#121212]/70 leading-relaxed">{v.body}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
